import { ClientParent } from '../models/client-parent';
import { Action } from '@ngrx/store';

export const LOAD = '[ClientParents] Load';
export const LOAD_COMPLETE = '[ClientParents] Load Complete';
export const LOAD_ERROR = '[ClientParents] Load Error';

export class Load implements Action {
  readonly type = LOAD;
  constructor( ) { }
}
export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: ClientParent[]) { }
}
export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any ) { }
}

export type Actions =
  Load |
  LoadComplete |
  LoadError;
